<template>
  <div class="app-container">
    <div class="screeBox">
      <el-form
        label-width="200px"
        :inline="true"
        :model="screen"
        class="demo-form-inline"
        label-position="top"
      >
        <el-form-item label="选择园区">
          <el-select
            class="screenInput"
            filterable
            v-model="screen.park_id"
            placeholder="请选择园区"
            :disabled="userInfo.park_id != 0"
            @change="parkChange"
          >
            <el-option label="全部园区" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择企业">
          <el-select
            class="screenInput"
            filterable
            v-model="screen.company_id"
            placeholder="请选择企业"
            @change="companyChange"
            :disabled="screen.user_house_id != ''"
          >
            <!-- @change="companyChange" -->
            <el-option label="全部企业" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in screenCompanyList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择住宅">
          <el-select
            class="screenInput"
            filterable
            v-model="screen.user_house_id"
            placeholder="请选择房间"
            @change="houseChange"
            :disabled="screen.company_id != ''"
          >
            <el-option label="全部住宅" value=""></el-option>
            <el-option
              :label="item.house_number"
              :value="item.id"
              v-for="(item, index) in houseList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择类型">
          <el-select
            class="screenInput"
            filterable
            v-model="screen.type"
            placeholder="请选择巡检类型"
          >
            <el-option label="全部类型" value=""></el-option>
            <el-option label="电" value="1"></el-option>
            <el-option label="水" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="选择付款状态">
          <el-select
            class="screenInput"
            filterable
            v-model="screen.status"
            placeholder="请选择付款状态"
          >
            <el-option label="全部付款状态" value=""></el-option>
            <el-option label="待付款" value="1"></el-option>
            <el-option label="付款成功" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择付款成功时间" style="width: 40%">
          <el-date-picker
            v-model="screen.pay_time"
            value-format="yyyy-MM-DD"
            type="daterange"
            range-separator="至"
            start-placeholder="付款成功开始日期"
            end-placeholder="付款成功结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="选择账单生成时间" style="width: 40%">
          <el-date-picker
            v-model="screen.create_time"
            value-format="yyyy-MM-DD"
            type="daterange"
            range-separator="至"
            start-placeholder="账单生成开始日期"
            end-placeholder="账单生成结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="labName">
          <el-button
            type="primary"
            @click="(screen.page = 1), fetchData()"
            style="margin-bottom: 5px"
            >搜索</el-button
          >
          <el-button
            type="primary"
            plain
            @click="reset()"
            style="margin-bottom: 5px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="50"> </el-table-column>
      <el-table-column label="所属园区" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="类型" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? "电" : "水" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账单生成时间" width="200">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.create_time }}</div>
        </template>
      </el-table-column>
      <el-table-column label="所属房间" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.snapshot">
            <span v-if="scope.row.snapshot.space_house">{{
              scope.row.snapshot.space_house.space.name +
              "-" +
              scope.row.snapshot.space_house.space_floor.name +
              "-" +
              scope.row.snapshot.space_house.house_number
            }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="所属租户" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.snapshot">
            <span v-if="scope.row.snapshot.company_id != 0">{{
              scope.row.snapshot.company
                ? scope.row.snapshot.company.name
                : "--"
            }}</span>
            <span v-if="scope.row.snapshot.user_house_id != 0">{{
              scope.row.snapshot.user_house
                ? scope.row.snapshot.user_house.name
                : "--"
            }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="父级仪表" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.snapshot">
            <div class="line2" v-if="scope.row.snapshot.energy">
              {{
                scope.row.snapshot.energy.p_info
                  ? scope.row.snapshot.energy.p_info.name
                  : "--"
              }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="子级仪表" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.snapshot">
            <div class="line2">
              {{
                scope.row.snapshot.energy
                  ? scope.row.snapshot.energy.name
                  : "--"
              }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="抄表时间" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.snapshot">
            <div class="line2">{{ scope.row.snapshot.create_time }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="抄表人" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.snapshot">
            <span>{{
              scope.row.snapshot.user ? scope.row.snapshot.user.name : "--"
            }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="抄表度数" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.snapshot">
            <span>{{ scope.row.snapshot.degree }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="使用度数（差额）" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.snapshot">
            <span>{{ scope.row.snapshot.use_degree }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="单价" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.snapshot">
            <span>{{ scope.row.snapshot.unit_price }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="缴纳金额" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.snapshot">
            <span>{{ scope.row.snapshot.price }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="数据来源">
        <template slot-scope="scope">
          <span>{{
            scope.row.snapshot.source == 1 ? "人工抄表" : "智能抄表"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="付款成功时间" width="200">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.pay_time }}</div>
        </template>
      </el-table-column>
      <el-table-column label="付款状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1" type="info" disable-transitions
            >待付款</el-tag
          >
          <el-tag
            v-if="scope.row.status == 2"
            type="success"
            disable-transitions
            >付款成功</el-tag
          >
          <el-tag v-if="scope.row.status == 3" type="danger" disable-transitions
            >付款失败</el-tag
          >
          <el-tag v-if="scope.row.status == 4" type="danger" disable-transitions
            >取消支付</el-tag
          >
          <el-tag
            v-if="scope.row.status == 5"
            type="warning"
            disable-transitions
            >已退款</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="250" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="affirm(scope.row.id)"
            v-if="
              roles.includes('/energy/order_change') && scope.row.status == 1
            "
            >付款成功</el-button
          >
          <el-button
            size="mini"
            type="warning"
            @click="handleInfo(scope.row.id)"
            v-if="roles.includes('/energy/order_info')"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <!-- <el-dialog title="开票审批" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item
          label="审核"
          prop="flag"
          :rules="[
            { required: true, message: '请选择审核', trigger: 'change' },
          ]"
        >
          <el-radio-group v-model="form.flag">
            <el-radio label="pass">通过</el-radio>
            <el-radio label="refuse">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          prop="remark"
          label="驳回原因"
          v-if="form.flag == 'refuse'"
        >
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog> -->
    <el-drawer
      size="800px"
      title="详情"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="infoForm"
        ref="infoForm"
        label-width="150px"
        class="demo-screen"
        :rules="infoRules"
      >
        <el-form-item label="所属园区" prop="park_id">
          <el-select
            filterable
            v-model="infoForm.park_id"
            placeholder="请选择园区"
            disabled
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属房间" prop="title">
          <el-input
            class="w4"
            disabled
            v-model="infoForm.houseName"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="infoForm.type" disabled>
            <el-radio :label="1">电</el-radio>
            <el-radio :label="2">水</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="数据来源" prop="source">
          <el-radio-group v-model="infoForm.source" disabled>
            <el-radio :label="1">人工抄表</el-radio>
            <el-radio :label="2">智能抄表</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="抄表时间：" prop="area">
          <el-input
            class="w4"
            disabled
            v-model="infoForm.create_time"
          ></el-input>
        </el-form-item>

        <el-form-item label="单价">
          <el-input
            class="w4"
            disabled
            v-model="infoForm.unit_price"
          ></el-input>
        </el-form-item>
        <el-form-item label="使用度数（差额）">
          <el-input
            class="w4"
            disabled
            v-model="infoForm.use_degree"
          ></el-input>
        </el-form-item>
        <el-form-item label="缴纳金额">
          <el-input class="w4" disabled v-model="infoForm.price"></el-input>
        </el-form-item>
        <el-form-item label="抄表度数" prop="degree">
          <el-input
            class="w4"
            :disabled="czType != 'edit'"
            v-model="infoForm.degree"
          ></el-input>
        </el-form-item>
        <el-form-item label="抄表图片" prop="image">
          <p v-if="infoForm.image">
            <el-image
              :src="imageOss + infoForm.image"
              class="tableIcon"
              fit="contain"
              :preview-src-list="$pathDispose(infoForm.image.split(','))"
            >
            </el-image>
          </p>
        </el-form-item>

        <!-- <el-form-item label="接收邮箱" prop="head_name">
          <el-input class="w4" disabled v-model="infoForm.email"></el-input>
        </el-form-item> -->
        <el-form-item>
          <!-- <el-button
            v-if="czType == 'see' && infoForm.status == 1"
            type="success"
            @click="czType = 'edit'"
          >
            编辑
          </el-button> -->
          <el-button
            v-if="czType == 'edit'"
            type="primary"
            @click="submitForm('infoForm')"
          >
            提交
          </el-button>
          <el-button type="info" @click="drawer = false"> 关闭 </el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog :visible.sync="imageVisible">
      <img width="100%" :src="imageOss + dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  openPark,
  delImage,
  openCompany,
  get_park_houses,
  openAgoUser,
} from "@/api/index";
import { examine } from "@/api/invoice";
import { orderLists, orderInfo, recordEdit, orderChange } from "@/api/energy";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      labName:'   ',
      infoForm: {},
      token: getToken(),
      list: [],
      listLoading: true,
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        type: "",
        company_id: "",
        user_house_id: "",
        status: "",
        create_time: [],
        pay_time: [],
        object: "park",
      },
      total: 0,
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      dialogVisible: false,
      form: {
        id: "",
        status: "",
        reason: "",
        url: "",
      },
      rules: {
        status: [{ required: true, message: "请选择审核", trigger: "change" }],
        remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
        reason: [
          { required: true, message: "请输入驳回意见", trigger: "blur" },
        ],
      },
      drawer: false,
      fileList: [],
      multipleSelection: [],
      screenCompanyList: [],
      czType: "see",
      infoRules: {
        degree: [
          { required: true, message: "请输入抄表度数", trigger: "blur" },
        ],
      },
      imageVisible: false,
      dialogImageUrl: "",
      houseList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
      this.parkChange(this.screen.park_id)
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    // 企业change
    companyChange() {
      this.screen.user_house_id = "";
    },
    // 房间change
    houseChange() {
      this.screen.company_id = "";
    },
    // 获取房间列表
    getHouse() {
      get_park_houses({
        park_id: this.screen.park_id,
      }).then((res) => {
        this.houseList = res.data;
      });
    },
    parkChange(e) {
      this.screen.space_id = "";
      this.screen.space_floor_id = "";
      this.screen.space_house_id = "";
      this.screen.company_id = "";
      this.getCompany("screen", e);
      this.getHouse();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    // 删除图片
    handleRemovePic(file, fileList) {
      this.fileList = fileList;
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.infoForm.image = list.join(",");
    },
    // 上传图片
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        this.fileList = fileList;
        if (this.infoForm.image) {
          this.delImg(this.infoForm.image);
        }
        this.infoForm.image = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
    },
    // 查看
    handleInfo(id) {
      var that = this;
      this.czType = "see";
      orderInfo({
        id: id,
        object: "park,company,user_house,energy_record,system_admin",
      }).then((res) => {
        that.infoForm = res.data.info;
        that.infoForm = {
          id: res.data.info.id,
          park_id: res.data.info.park_id,
          type: res.data.info.type,
          image: res.data.info.snapshot.image,
          create_time: res.data.info.snapshot.create_time,
          degree: res.data.info.snapshot.degree,
          use_degree: res.data.info.snapshot.use_degree,
          unit_price: res.data.info.snapshot.unit_price,
          price: res.data.info.snapshot.price,
        };
        if (res.data.info.snapshot.space_house) {
          that.infoForm.houseName =
            res.data.info.snapshot.space_house.space.name +
            "-" +
            res.data.info.snapshot.space_house.space_floor.name +
            "-" +
            res.data.info.snapshot.space_house.house_number;
        }
      });

      this.drawer = true;
    },
    affirm(id) {
      var that = this;
      this.$confirm("是否已付款成功？")
        .then(() => {
          orderChange({
            id: id,
            status: 2,
            system_admin_id: this.userInfo ? this.userInfo.id : "",
          }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    reset() {
      this.screen = {
        page: 1,
        page_size: 15,
        park_id: "",
        type: "",
        company_id: "",
        user_house_id: "",
        status: "",
        create_time: [],
        pay_time: [],
        object: "park",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 编辑提交
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: that.infoForm.id,
            degree: that.infoForm.degree,
            image: that.infoForm.image,
          };
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading",
          });
          recordEdit(data).then((res) => {
            loading.close();
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.drawer = false;
              that.fetchData();
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });
          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.screen.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },

    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1,id:this.screen.park_id,source:'energy' }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 获取企业列表
    getCompany(type, id, index) {
      var data = {
        park_id: id,
        is_page: 2,
      };
      openCompany(data).then((response) => {
        if (type == "screen") {
          this.screenCompanyList = response.data.lists;
        } else if (type == "add") {
          this.companyList = response.data.lists;
        }
      });
    },
    // 获取列表
    fetchData() {
      this.listLoading = true;
      let data = {
        page: this.screen.page,
        page_size: this.screen.page_size,
        park_id: this.screen.park_id,
        type: this.screen.type,
        company_id: this.screen.company_id,
        user_house_id: this.screen.user_house_id,
        status: this.screen.status,
        create_time: this.screen.create_time
          ? this.screen.create_time.toString(",")
          : "",
        pay_time: this.screen.pay_time
          ? this.screen.pay_time.toString(",")
          : "",
        object: "park",
      };
      // return
      orderLists(data).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 100px;
  height: 50px;
}
// .screenInput {
//   width: 200px;
//   margin: 0 10px 10px;
// }
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}

.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
  .el-input {
    width: 200px;
  }
  .el-form--inline .el-form-item {
    width: 20%;
    margin-bottom: 0;
    margin-right: 0;
  }
  .el-form--label-top .el-form-item__label{
    padding: 0;
  }
}

.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
::v-deep .el-upload-list__item {
  transition: none !important;
}
</style>
